import axios from "axios";
import {DOMEN} from './domen'

const googleLogin = async (token) => {
  let res = await axios.post(
      DOMEN+"/api/rest-auth/google/", {
        access_token: token,
      }
  );
  await localStorage.setItem('JWTToken', res.data.token)
    await localStorage.setItem('first_name', res.data.user?.first_name)
    await localStorage.setItem('last_name', res.data.user?.last_name)
  axios.defaults.headers.common['Authorization'] = `jwt ${res.data.token}`;
};

export const checkJWTToken = (jwt) => {
  axios.defaults.headers.common['Authorization'] = `jwt ${jwt}`;
};

export const setupAxiosInterceptors = () => {
  axios.interceptors.response.use(
    response => response,
    error => {
      if (error.response?.status === 401) {
        localStorage.clear();
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }
  );
};

export default googleLogin